import React from "react";
import { Control } from "react-hook-form";

import { Checkbox } from "../../form_components/Inputs";
import { NoticeFilters } from "../utils";

import css from "./SharedFilterGroups.module.scss";

interface Props {
  control: Control<NoticeFilters, unknown>;
}

export function HiddenNoticesFilterGroup({ control }: Props) {
  return (
    <div className={css.filterSection} aria-label="Hidden notices filter">
      <Checkbox
        name="includeHiddenNotices"
        control={control}
        label=""
        fieldLabel="Include hidden notices"
      />
    </div>
  );
}
